import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { confirm } from "@/shared/lib/confirm";
import { getInitials } from "@/shared/lib/utils";
import { resolveImageSrc } from "@/shared/ui/AppImage";
import { useNavigate } from "@tanstack/react-router";
import { LogOut, UserRound } from "lucide-react";
import { useAuthState } from "../model/useAuthState";

export function ProfileDropdown() {
  const { user, signOut } = useAuthState();
  const navigate = useNavigate({ from: "/app" });

  const handleSignOut = async () => {
    const ok = await confirm({
      title: "ອອກຈາກລະບົບ",
      description:
        "ທ່ານແນ່ໃຈບໍ່ວ່າຈະອອກຈາກລະບົບ? ຈະຕ້ອງເຂົ້າລະບົບໃໝ່ເພື່ອເຂົ້າໃຊ້ບັນຊີ.",
      actionText: "ອອກຈາກລະບົບ",
      cancelText: "ຍົກເລີກ",
      ActionProps: { variant: "destructive" },
    });
    if (!ok) return;
    await signOut();
    navigate({ to: "/auth/login" });
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage
              src={resolveImageSrc(user?.image) ?? ""}
              alt={user?.name ?? "user"}
            />
            <AvatarFallback>{getInitials(user?.name ?? "User")}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col gap-1.5">
            <p className="font-medium text-sm leading-none">
              {user?.name ?? "ຜູ້ໃຊ້"}
            </p>
            <p className="text-muted-foreground text-xs leading-none">
              {user?.email ?? ""}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate({ to: "/app/profile" })}>
          <UserRound />
          ໂປຣໄຟລ໌
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleSignOut}>
          <LogOut />
          ອອກຈາກລະບົບ
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
